/**
 * STEP INITIALISING, NAVIGATION
 * All Steps are marked up using 'article',
 * iterate over steps and add incremental 
 * 'step_X' classes: step_1, step_2, etc.
 */
import $ from 'jquery';
//import aon_craft_sliders from './aon_craft_sliders.js';
//import aon_craft_product_randomiser from './aon_craft_product_randomiser.js';
import aon_craft_onboarding from './aon_craft_onboarding.js';
import aon_craft_calendar from './aon_craft_calendar.js';
import aon_craft_sliders from './aon_craft_sliders.js';
import aon_craft_triangles_circles from './aon_craft_triangles_circles.js';
import aon_craft_particles from './aon_craft_particles.js';
import aon_craft_add_person from './aon_craft_add_person.js';
import aon_craft_section_1a from './aon_craft_section_1a.js';
import aon_craft_section_2a from './aon_craft_section_2a.js';
import aon_craft_section_2b from './aon_craft_section_2b.js';
import aon_craft_section_3b from './aon_craft_section_3b.js';
import aon_craft_section_2c from './aon_craft_section_2c.js';
import aon_craft_todos from './aon_craft_todos.js';
import aon_craft_section_3c from './aon_craft_section_3c.js';
import aon_craft_product_randomiser from './aon_craft_product_randomiser.js';
import aon_craft_customer_creator from './aon_craft_customer_creator.js';
import aon_craft_section_4a from './aon_craft_section_4a.js';
import aon_craft_section_4b from './aon_craft_section_4b.js';
import aon_craft_section_5a from './aon_craft_section_5a.js';
import aon_craft_section_5b from './aon_craft_section_5b.js';
import aon_craft_section_5c from './aon_craft_section_5c.js';
import chartist from './chartist.min.js';

window.jQuery = $;

export default {
    init() {
        /*
         * Initialise STEP INITIALISING, NAVIGATION
         */
        //console.log( 'STEP INITIALISING, NAVIGATION - init' );
        

        // INITIALISING STEPS...
        this.current_step = 1; // Set default current step var to 1
        //console.log( 'start - current_step: ' + this.current_step );
        this.total_steps = 0; // Init total steps var
        //console.log( 'total_steps: ' + this.total_steps );
        
        var incStepsTotal = ( inc ) => {
            this.total_steps = inc;
            //console.log( 'this.total_steps: ' + this.total_steps);
        }
        
        $( 'article' ).hide(); // Hide all at first...
        $( 'article' ).each( function( index ) {
            // add numbered class to each section...
            $( this ).addClass( 'step_' + ( index + 1 ) );
            incStepsTotal( index + 1 );
        });
        
        
        var showFirstStep = () => {
            $( '.step_' + this.current_step ).show();
            this.restartAnimatedSvgs( this.current_step );
            //console.log( 'total_steps: ' + this.total_steps );
        }
        
        $( 'article' ).promise().done( function() {
            // Upon completion of iterating over steps then show step 1.
            showFirstStep();
        });
        
		if ( $( 'section' ).length > 0 ) {
			this.current_section = $( 'section' ).attr( 'class' ).replace( 'trigger', '' ).replace( 'prevent-interaction', '' ).trim(); // Get current section class
		} else {
			this.currentsection = 'nocurrentsection';
		}
        //console.log( 'this.current_section: ' + this.current_section );
        
        this.initJSForSections( this.current_section );

        this.showSectionTitleHeader( this.current_step );
        
        this.showMainNavDuringExercise( this.current_step, this.current_section );

        /*
         * STEP BUTTON INTERACTION...
         */
        // Forwards...
        $( '.button[href="#next"], .button[href="#save"]' ).on( 'click', function( event ) {
            if ( !$( this ).hasClass( 'disabled' ) ) { // Check button is not disabled...
                changeStepNext();
            }
            event.preventDefault();
        });
        // Backwards...
        $( '.button[href="#back"]' ).on( 'click', function( event ) {
            if ( !$( this ).hasClass( 'disabled' ) ) { // Check button is not disabled...
                changeStepPrev();
            }
            event.preventDefault();
        });
        
        var changeStepNext = () => {
            this.changeStep( 'next' );
        }

        var changeStepPrev = () => {
            this.changeStep( 'prev' );
        }
        
        var hash = location.hash;
        //console.log( hash );
        if ( hash.substr(1, 4)  == 'goto' ) {
            var goto_step = parseInt( hash.substr(5), 10);
            //console.log( goto_step );
            this.changeStep( goto_step );
        }

    },
    
    // STEP NAVIGATION...
    // First, we calculate which step we are going to...
    changeStep( mode ) {
        // 'mode' can be: next, prev or specific step number
        if ( mode === 'next' ) {
            this.renderStep( this.current_step + 1 );

        } else if ( mode === 'prev' ) {
            this.renderStep( this.current_step - 1 );

        } else if ( Number.isInteger( mode ) ) {
            // Go to specific step
            this.renderStep( mode );

        } else {
            // mode neither direction or step number. Do nothing.
            //console.log( 'Sorry, the "mode" supplied to the changeStep function was neither a direction or step number. Mode: ' + mode );
        }
        //console.log( 'changeStep - current_step: ' + this.current_step );
    },
    
    // Second, we try to go to and render the step, but only if
    // it is within the available steps of 1 to total steps.
    renderStep( step ) {
        if ( step > 0 && step <= this.total_steps ) {
            // Render step...
            this.current_step = step;
            $( 'article' ).hide();
            $( 'article.step_' + step ).show();
            this.restartAnimatedSvgs( step );

			console.log('renderStep currentstep',this.current_step);
			
            // Init any Orbit Sliders on the current Step...
            if ( $( 'article.step_' + step + ' .orbit' ).length ) {
                var slider_id = $( 'article.step_' + step + ' .orbit' ).attr( 'id' );
                //console.log( 'slider_id: ' + slider_id );
                //console.log( 'article.step_' + step + ' .orbit' );
                aon_craft_sliders.sliderInit( slider_id ); 
                aon_craft_sliders.getActiveSlideNumber( slider_id ); // Send ID of slider without the '#'
                aon_craft_sliders.sliderChange( slider_id );
            }
            
            // Init any range sliders on the current Step...
            if ( $( '.slider.vertical' ).length ) {
                $( '.slider.vertical' ).foundation( '_reflow' );
            }

            if ( $( '.product_randomiser' ).length ) {
                aon_craft_product_randomiser.setSlotHeight();
            }

            this.showSectionTitleHeader( step );
            this.showMainNavDuringExercise( step, this.current_section );
            
            // Adding People in Section 1B, we need to disable adding Internal people on Step 9 "Add any other external individuals..."
            if ( this.current_section == 'section_1b' ) {
                if ( this.current_step == 8 ) {
                    //console.log( "Disable Adding Internal People here" );
                }
            }
            
            // In Section 4B, we need to trigger a keyup on the `#s4_b_cashflow_form_step_4_salary_each_year` field so that the related monthly salary is calculated and displayed
            if ( this.current_section == 'section_4b' ) {
                if ( this.current_step == 8 ) {
                    $( '#s4_b_cashflow_form_step_4_salary_each_year' ).trigger( 'keyup' ); 
                }
            }
            
            // Scroll to top of page
            $( 'html, body' ).animate({ scrollTop: 0 }, 'fast');

        } else {
            // step either 0 or higher than the total amount of available steps.
            //console.log( 'Sorry, the intended "step" was either 0 or higher than the total amount of available steps. Step: ' + step );
        }

    },

    // Replacing an inline SVG gives its one-shot CSS animations a fresh
    // timeline whenever the containing step becomes visible.
    restartAnimatedSvgs( step ) {
        $( 'article.step_' + step + ' .svg-animated-image svg' ).each( function() {
            this.parentNode.replaceChild( this.cloneNode( true ), this );
        });
    },
    
    showSectionTitleHeader( step ) {
            // Show / Hide small 'section_title_header' if not on Step 1
            if ( step == 1 ) {
                $( '.section_title_header' ).addClass( 'hidden' );
            } else {
                $( '.section_title_header' ).removeClass( 'hidden' );
            }
    },
    
    showMainNavDuringExercise( step, section ) {
            // Show / Hide main nav button on Section Start page, Section Menu page and Step 1 of excercises
			//console.log( 'Which section: ' + section );
            if ( ( step == 1 && section != 'dashboard' && section != 'account' && section != 'business_plan_section' && section != 'todos_section' && section != 'videos_section' && section != 'resources_section' && section != 'userguides_section' && section != 'error_404' && section != 'all_sections_completed_survey_section' ) || ( section == 'section_1' || section == 'section_2' || section == 'section_3' || section == 'section_4' || section == 'section_5' ) ) {
                $( 'header nav' ).addClass( 'hidden' );
            /*} else if ( current_section == 'section_1' || current_section == 'section_2' || current_section == 'section_3' || current_section == 'section_4' ) {
                $( 'header nav' ).addClass( 'hidden' );  */          
            } else {
                $( 'header nav' ).removeClass( 'hidden' );
            }
    },
    
    initJSForSections( section ) {
        if ( section == 'onboarding' ) {
            aon_craft_onboarding.init();
            
        } else if ( section == 'dashboard' ) {
            aon_craft_particles.init();
            
        } else if ( section == 'business_plan_section' ) {
            aon_craft_calendar.init();
            aon_craft_section_2b.init();
            aon_craft_customer_creator.renderExistingCustomers();
            aon_craft_section_4a.init();
            aon_craft_section_4b.loadFinalProfitLoss();
            aon_craft_section_5c.init();
            
        } else if ( section == 'todos_section' ) {
            aon_craft_todos.init();
            
        } else if ( section == 'videos_section' ) {
            //aon_craft_todos.init();
            
        } else if ( section == 'resources_section' ) {
            //aon_craft_todos.init();
            
        } else if ( section == 'section_1a' ) {
            aon_craft_triangles_circles.init();
            aon_craft_section_1a.init();
            aon_craft_calendar.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_1b' ) {
            aon_craft_add_person.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_2a' ) {
            aon_craft_product_randomiser.init();
            aon_craft_section_2a.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_2b' ) {
            aon_craft_section_2b.init();
            aon_craft_calendar.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_2c' ) {
            aon_craft_section_2c.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_3a' ) {
            aon_craft_customer_creator.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_3b' ) {
            aon_craft_section_3b.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_3c' ) {
            aon_craft_section_3c.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_4a' ) {
            aon_craft_section_4a.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_4b' ) {
            aon_craft_section_4b.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_5a' ) {
            aon_craft_section_5a.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_5b' ) {
            aon_craft_section_5b.init();
            aon_craft_product_randomiser.init();
            aon_craft_todos.init();
            
        } else if ( section == 'section_5c' ) {
            aon_craft_section_5c.init();
            aon_craft_todos.init();
            
        } else {
            
        }
        
    }
  
}
